module.exports = __webpack_public_path__ + "static/media/arrow.39003cb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/common/arrow.svg
// module id = 938
// module chunks = 0